import { openCloseToast } from "../../../Global/actions";
import { getAllRoles } from "../../../../services/rolesApi";
import { getAllProfiles } from "../../../../services/perfilesApi";
import { getAllCompanies } from "../../../../services/companiesApi"

import { doGetRolesTrabajadorFilters, doGetRolesEmpresaFilters } from '../../Empresa/GestionUsuarios/AsignacionRoles/actions'

import { async } from "q";

export const setDataListas = (mantenedores) => ({
  type: "SET_DATA_LISTAS",
  mantenedores,
});

// nuevo llenado de listado roles
export const setRolesList = (roles) => ({
  type: "SET_ROLES_LIST",
  roles,

});
// nuevo llenado de listado perfiles
export const setPerfilesList = (perfiles) => ({
  type: "SET_PERFILES_LIST",
  perfiles,

});

export const setEmpresasList = (empresas) => ({
  type: "SET_EMPRESAS_LIST",
  empresas,
});

export const loadingRoles = (isLoadingRoles) => ({
  type: "LOADING_ROLES",
  isLoadingRoles,
});


export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDORES",
  isLoading,
});

export const setSelectedFuncionalities = (func) => ({
  type: "SET_ROL_FUNCIONALITIES",
  func,
});

export const setEventDataRol = (eventDataRol) => ({
  type: "SET_EVENT_DATA_ROL",
  eventDataRol,
});

export const getEmpresas = () => async (dispatch) => {
  try {
    const _empresas = await getAllCompanies();
    const empresas = await getAllProfiles();
    if (empresas.status === 200) {
      const result = await empresas.json();
      dispatch(setEmpresasList(_empresas.Data, null));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar los empresas",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener empresas",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
}

export const getPerfiles = () => async (dispatch) => {
  try {
    const perfiles = await getAllProfiles();
    if (perfiles.status === 200) {
      const result = await perfiles.json();
      dispatch(setPerfilesList(result.Data, null));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar los perfiles",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener perfiles",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
};

export const getRoles = (showMessege) => async (dispatch) => {
  if (showMessege) dispatch(loadingRoles(true));
  try {
    const roles = await getAllRoles();
    if (roles.status === 200) {
      const result = await roles.json();
      dispatch(setRolesList(result.Data));
      dispatch(doGetRolesTrabajadorFilters(result.Data))
      dispatch(doGetRolesEmpresaFilters(result.Data))
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar los Roles",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener los roles",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  if (showMessege) dispatch(loadingRoles(false));
};
